import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0f111a', // mörkblåsvart
    },
    text: {
      primary: '#c6a04c', // guldfärg
    },
    primary: {
      main: '#c6a04c',
    },
    secondary: {
      main: '#1a1a1a',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
});

export default theme;
